import React from "react";
import { omit } from "lodash";
import { Location } from "@reach/router";
import Layout from "./src/layouts/index";
import SecurityProvider from "./src/components/security-provider";
import { ProvideTargetContext } from "./src/target-context";
import OrderingHome from "./src/templates/index";

export default ({ element, props }) => {
  const { pageContext: { target = 'ordering' } } = props;
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  const {
    location: { pathname },
    pageContext,
  } = props;

  if (
    props.custom404 ||
    element.key === "/404.html" ||
    pathname === "/404.html" ||
    pathname === "/404/"
  ) {
    return element;
  }

  const businessAppConfiguration = pageContext.businessAppConfiguration || {};
  const websiteEnabled = pageContext.websiteEnabled;
  const { useRecaptchaInSignUp } = businessAppConfiguration;
  const { recaptchaKey, captchaProvider, hcaptchaKey } = businessAppConfiguration;

  const isOrderSubdomain = typeof window !== 'undefined' && (window.location.hostname.startsWith('order.') || window.location.hostname.includes('cloudfront'));
  const isNativeApp = typeof window !== 'undefined' && window.isNativeApp;
  const shouldRenderOrderingHome = (websiteEnabled && (isOrderSubdomain || isNativeApp)) && pathname === "/" && pageContext.isNewWebsiteLayout;
  const layoutProps = omit(props, "data");

  if (shouldRenderOrderingHome) {
    layoutProps.pageContext.isNewWebsiteLayout = false;
  }

  const content = shouldRenderOrderingHome ? (
    <OrderingHome {...props} />
  ) : (
    element
  );

  return (
    <ProvideTargetContext target={target}>
      <Location>
        {({ location }) => (
          <SecurityProvider
            recaptchaKey={recaptchaKey}
            hcaptchaKey={hcaptchaKey}
            captchaProvider={captchaProvider}
          >
            <Layout {...layoutProps} location={location}>
              {content}
            </Layout>
          </SecurityProvider>
        )}
      </Location>
    </ProvideTargetContext>
  );
};
